import { render, staticRenderFns } from "./PapercleanDocumentiTipiPage.vue?vue&type=template&id=a524b1c6"
import script from "./PapercleanDocumentiTipiPage.vue?vue&type=script&lang=js"
export * from "./PapercleanDocumentiTipiPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports